import apiClient from "./client";

/**
 * Pioneer IPTV — DPO + FTA + add-ons, 1/3/6/12-month recharges.
 * Backend: portal_php/customer/pioneeriptv/*.php and customer/recharge_pioneeriptv.php
 */
const BASE = "/customer/pioneeriptv";

/**
 * DPOs, FTA, add-ons (with channels), month options, paid-till per STB, wallet.
 * opts: { dpoPackId, dpoPlanId (combos saved before Pioneer left ott_plans), currentPkgids (advance) }
 */
export const pioneerRechargeOptions = (userId, opts = {}) =>
  apiClient.get(`${BASE}/pioneer_recharge_options.php`, {
    params: {
      user_id: userId,
      dpo_pack_id: opts.dpoPackId || undefined,
      dpo_plan_id: opts.dpoPlanId || undefined,
      current_pkgids: opts.currentPkgids !== undefined ? opts.currentPkgids : undefined,
    },
  });

/** Pioneer pkgids of a box's current plans, for pioneerRechargeOptions(..., { currentPkgids }). */
export const stbPkgids = (stb) => ((stb && stb.plans) || []).map((p) => p.pkgid).filter(Boolean).join(",");

/** { paid_till: { device_id: "Y-m-d H:i:s" } } */
export const pioneerStbStatus = (userId) =>
  apiClient.get(`${BASE}/pioneer_stb_status.php?user_id=${userId}`);

/** { user_id, device_id, branch_id, plan_id, addon_ids, months, advance } */
export const pioneerRecharge = (payload) =>
  apiClient.post("/customer/recharge_pioneeriptv.php", payload);

export const pioneerBranches = (operatorId) =>
  apiClient.get(`/customer/get_pioneeriptv_branches.php?operator_id=${operatorId}`);

// ── super admin ─────────────────────────────────────────────
export const pioneerPacks = (params = {}) =>
  apiClient.get(`${BASE}/pioneer_packs.php`, { params });
export const pioneerPacksSync = (channels = true) =>
  apiClient.post(`${BASE}/pioneer_packs.php`, { action: "sync", channels });
export const pioneerPackUpdate = (id, patch) =>
  apiClient.post(`${BASE}/pioneer_packs.php`, { action: "update", id, ...patch });
/** price back to Pioneer price + GST (follows future syncs) */
export const pioneerPackReset = (id) =>
  apiClient.post(`${BASE}/pioneer_packs.php`, { action: "reset", id });

export const pioneerRenewals = (params = {}) =>
  apiClient.get(`${BASE}/pioneer_renewals.php`, { params });
export const pioneerRenewalRetry = (id) =>
  apiClient.post(`${BASE}/pioneer_renewals.php`, { action: "retry", id });
export const pioneerRenewalCancel = (batch) =>
  apiClient.post(`${BASE}/pioneer_renewals.php`, { action: "cancel", batch });
